"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBillingInformationToRecipientOptions = transformBillingInformationToRecipientOptions;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const transformCurrencyToMangoPayCurrency_1 = require("./transformCurrencyToMangoPayCurrency");
const transformDomainCountryToMangopayCountry_1 = require("./transformDomainCountryToMangopayCountry");
const transformToMangopayAddress_1 = require("./transformToMangopayAddress");
const transformToMangopayName_1 = require("./transformToMangopayName");
function transformBillingInformationToRecipientOptions(billingInformation, countries, currency) {
    const { bankAccountCountry, residenceCountry, headquartersAddressCountry } = countries;
    const isLegal = billingInformation.type === legacy_enums_1.BillingInformationType.Legal;
    const recipientInfo = getRecipientInfo(isLegal ? "Business" : "Individual", billingInformation, residenceCountry, headquartersAddressCountry);
    const bankTransferInfo = getBankTransferInfo(billingInformation, bankAccountCountry);
    const recipientOptions = {
        DisplayName: (0, transformToMangopayName_1.transformToMangopayName)(billingInformation),
        PayoutMethodType: bankTransferInfo.InternationalBankTransfer ? "InternationalBankTransfer" : "LocalBankTransfer",
        RecipientType: isLegal ? "Business" : "Individual",
        Country: (0, transformDomainCountryToMangopayCountry_1.transformDomainCountryToMangopayCountry)(bankAccountCountry.isoCode),
        Currency: (0, transformCurrencyToMangoPayCurrency_1.transformCurrencyToMangoPayCurrency)(currency),
        RecipientScope: "PAYOUT",
        ...recipientInfo,
        ...bankTransferInfo,
    };
    return recipientOptions;
}
function getRecipientInfo(type, billingInformation, residenceCountry, headquartersAddressCountry) {
    return type === "Business"
        ? {
            BusinessRecipient: {
                BusinessName: (0, transformToMangopayName_1.transformToMangopayName)(billingInformation),
                Address: (0, transformToMangopayAddress_1.transformToMangopayAddress)(billingInformation.headquartersAddress, headquartersAddressCountry),
            },
        }
        : {
            IndividualRecipient: {
                FirstName: billingInformation.firstName,
                LastName: billingInformation.lastName,
                Address: (0, transformToMangopayAddress_1.transformToMangopayAddress)(billingInformation.address, residenceCountry),
            },
        };
}
function getBankTransferInfo(billingInformation, bankAccountCountry) {
    switch (billingInformation.bankType) {
        case legacy_enums_1.CountryBankType.IBAN:
            return bankAccountCountry.isInSepa
                ? {
                    LocalBankTransfer: {
                        EUR: {
                            IBAN: billingInformation.iban.replace(/\s/g, ""),
                        },
                    },
                }
                : {
                    InternationalBankTransfer: {
                        AccountNumber: billingInformation.iban.replace(/\s/g, ""),
                    },
                };
        case legacy_enums_1.CountryBankType.BIC:
            return {
                InternationalBankTransfer: {
                    AccountNumber: billingInformation.accountNumber.replace(/\s/g, ""),
                    BIC: billingInformation.bic.replace(/\s/g, ""),
                },
            };
        case legacy_enums_1.CountryBankType.US:
            return {
                LocalBankTransfer: {
                    AccountNumber: billingInformation.accountNumber.replace(/\s/g, ""),
                    ABA: billingInformation.aba.replace(/\s/g, ""),
                },
            };
        default:
            throw new Error("Unsupported type of bank account.");
    }
}
//# sourceMappingURL=transformBillingInformationToRecipientOptions.js.map